import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewMoneda = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'moneda',
        name: 'Moneda',
        component: ViewMoneda,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
